import React from "react";
import {styled, theme} from "@reside/ui";
import {TableUserDto} from "../../../../utils/types/user";
import {readableRole} from "../../../../atoms/list-table/helpers";
import {FacilityNamesOverflow} from "./FacilityNamesOverflow";

type Props = Readonly<{
  user: TableUserDto;
}>;

export const PermissionsUserMeta = ({user}: Props) => {
  const items: Array<{key: string; content: React.ReactNode}> = [];

  if (user.role) {
    items.push({key: "role", content: readableRole(user.role as any)});
  }

  if (user.organization?.name) {
    items.push({key: "organization", content: user.organization.name});
  }

  if (user.facilities?.length) {
    items.push({
      key: "facilities",
      content: <FacilityNamesOverflow facilities={user.facilities} />,
    });
  }

  if (user.email) {
    items.push({key: "email", content: user.email});
  }

  if (items.length === 0) {
    return null;
  }

  return (
    <Root>
      {items.map((item, index) => (
        <React.Fragment key={item.key}>
          {index > 0 ? <Separator aria-hidden="true">·</Separator> : null}
          <Item>{item.content}</Item>
        </React.Fragment>
      ))}
    </Root>
  );
};

const Root = styled.div`
  align-items: baseline;
  color: ${theme.color.gray150};
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 32px;
  margin-bottom: 20px;
`;

const Item = styled.span`
  min-width: 0;
`;

const Separator = styled.span`
  margin: 0 8px;
`;
